export const APP_NAME = "EN Connect";
export const DEVICE_TYPE_DESKTOP = "desktop";